import {
  GamoraConstructorType,
  GamoraFoundationNode,
  GamoraFoundationNodeArgs,
} from '@ver.id/libs.internal.gamora';
import {
  HoruzProtocolChulakClientController,
  HoruzProtocolChulakClientControllerArgs,
} from './client.js';
import {
  HoruzProtocolChulakServerController,
  HoruzProtocolChulakServerControllerArgs,
} from './server.js';
import {
  HoruzProtocolChulakServiceController,
  HoruzProtocolChulakServiceControllerArgs,
} from './service.js';
import {
  HoruzProtocolChulakStoreNode,
  HoruzProtocolChulakStoreNodeArgs,
} from './stores/store.js';
import {
  HoruzProtocolChulakTaskNode,
  HoruzProtocolChulakTaskNodeArgs,
} from './tasks/task.js';
import { IHoruz } from '../../horuz.js';

/**
 * Children map
 * @public
 */
export interface HoruzProtocolChulakNodeChildrenMap<TRoot extends IHoruz> {
  client: GamoraConstructorType<
    HoruzProtocolChulakClientController<TRoot>,
    HoruzProtocolChulakClientControllerArgs<TRoot>
  >;
  server: GamoraConstructorType<
    HoruzProtocolChulakServerController<TRoot>,
    HoruzProtocolChulakServerControllerArgs<TRoot>
  >;
  service: GamoraConstructorType<
    HoruzProtocolChulakServiceController<TRoot>,
    HoruzProtocolChulakServiceControllerArgs<TRoot>
  >;
  store: GamoraConstructorType<
    HoruzProtocolChulakStoreNode<TRoot>,
    HoruzProtocolChulakStoreNodeArgs<TRoot>
  >;
  tasks: GamoraConstructorType<
    HoruzProtocolChulakTaskNode<TRoot>,
    HoruzProtocolChulakTaskNodeArgs<TRoot>
  >;
}

/**
 * Args
 * @public
 */
export interface HoruzProtocolChulakNodeArgs<
  TRoot extends IHoruz,
> extends GamoraFoundationNodeArgs<HoruzProtocolChulakNodeChildrenMap<TRoot>> {
  client?: HoruzProtocolChulakClientControllerArgs<TRoot>;
  server?: HoruzProtocolChulakServerControllerArgs<TRoot>;
  service?: HoruzProtocolChulakServiceControllerArgs<TRoot>;
  store?: HoruzProtocolChulakStoreNodeArgs<TRoot>;
  tasks?: HoruzProtocolChulakTaskNodeArgs<TRoot>;
}

/**
 * HoruzProtocolChulakNode
 *
 * @public
 */
export class HoruzProtocolChulakNode<
  TRoot extends IHoruz,
> extends GamoraFoundationNode<
  HoruzProtocolChulakNodeChildrenMap<TRoot>,
  TRoot
> {
  constructor(args: HoruzProtocolChulakNodeArgs<TRoot>) {
    super({
      ...args,
      childMap: {
        client: [HoruzProtocolChulakClientController, args.client ?? {}],
        server: [HoruzProtocolChulakServerController, args.server ?? {}],
        service: [HoruzProtocolChulakServiceController, args.service ?? {}],
        store: [HoruzProtocolChulakStoreNode, args.store ?? {}],
        tasks: [HoruzProtocolChulakTaskNode, args.tasks ?? {}],
      },
    });
  }
}
